export default [
  {
    path: '/park',
    name: 'Park',
    component: resolve => require(['@/views/Park'], resolve),
    meta: {
      keepAlive: true // 需要被缓存
    }
  },
  // 新增-编辑
  {
    path: '/park/modify-form',
    name: 'ParkEC',
    component: resolve => require(['@/views/Park/Form/Form'], resolve)
  }
]
